import { create } from 'zustand';
import type { LibraryDocument } from '@hump/shared-types';
import { libraryRepository } from '../lib/repository';
import { docRepository } from '../lib/repository/doc';

interface LibraryState {
  documents: LibraryDocument[];
  loading: boolean;
  error: string | null;

  loadLibrary: () => Promise<void>;
  importFile: (filename: string, content: ArrayBuffer | string) => Promise<void>;
  deleteDoc: (docId: string) => Promise<void>;
}

export const useLibraryStore = create<LibraryState>((set) => ({
  documents: [],
  loading: false,
  error: null,

  loadLibrary: async () => {
    set({ loading: true, error: null });
    try {
      const lib = await libraryRepository.getLibrary();
      set({ documents: lib.documents, loading: false });
    } catch (e) {
      set({ error: (e as Error).message, loading: false });
    }
  },

  importFile: async (filename, content) => {
    set({ error: null });
    try {
      await docRepository.importFile(filename, content);
      const lib = await libraryRepository.getLibrary();
      set({ documents: lib.documents });
    } catch (e) {
      const msg = (e as Error).message;
      set({ error: msg });
      throw e; // 重新抛出让调用方（ImportButton）能捕获并保留用于重试
    }
  },

  deleteDoc: async (docId) => {
    set({ error: null });
    try {
      await docRepository.deleteDoc(docId);
      set((state) => ({
        documents: state.documents.filter((d) => d.id !== docId),
      }));
    } catch (e) {
      set({ error: (e as Error).message });
    }
  },
}));
